module.exports = {"370785001":"高密市朝阳街道","370785002":"高密市醴泉街道","370785003":"高密市密水街道","370785100":"柏城镇","370785103":"夏庄镇","370785104":"姜庄镇","370785106":"大牟家镇","370785109":"阚家镇","370785111":"井沟镇","370785114":"柴沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370785.json
// module id = 1312
// module chunks = 0